export const ETAB_EVENTS = {
  LAYOUT_INSCRIPTION: {
    ON_NEXT: "LAYOUT_INSCRIPTION.ON_NEXT",
  },
  STEPS: {
    NEXT_STEP: "STEPS.NEXT_STEP",
  },
  RECRUITMENT: {
    CANCEL: "RECRUITMENT.CANCEL",
    CDI_REVIEW: "RECRUITMENT.CDI_REVIEW",
    GO_TO_CREATION: "RECRUITMENT.GO_TO_CREATION",
    GO_TO_DETAILS: "RECRUITMENT.GO_TO_DETAILS",
    GO_TO_PERMANENT_FEEDBACK: "RECRUITMENT.GO_TO_PERMANENT_FEEDBACK",
    OPEN_RECRUITMENT_RECAP: "RECRUITMENT.OPEN_RECRUITMENT_RECAP",
    REFRESH: "RECRUITMENT.REFRESH",
    RESTART: "RECRUITMENT.RESTART",
  },
  CANDIDATE: {
    IGNORE: "CANDIDATE.IGNORE",
    CONTACT: "CANDIDATE.CONTACT",
    GO_TO_PROFILE: "CANDIDATE.GO_TO_PROFILE",
  },
  EXTRA: {
    CANCEL_SHIFTS: "EXTRA.CANCEL_SHIFTS",
  },
  REVIEW: {
    IGNORE_REVIEW: "REVIEW.IGNORE_REVIEW",
    DECLARE_MISSING: "REVIEW.DECLARE_MISSING",
    UPDATE_SCHEDULE: "REVIEW.UPDATE_SCHEDULE",
    CONFIRM_SCHEDULE: "REVIEW.CONFIRM_SCHEDULE",
    OPEN_REVIEW: "REVIEW.OPEN_REVIEW",
  },
  HOURLY_RECORD: {
    DECLARE_MISSING: "DECLARE_MISSING.DECLARE_MISSING",
  },
  SHIFT_PLANNING: {
    GET_CALENDAR_FROM_DATE: "SHIFT_PLANNING.GET_CALENDAR_FROM_DATE",
    GET_SHIFTS_FROM_DATES: "SHIFT_PLANNING.GET_SHIFTS_FROM_DATES",
    REFRESH: "SHIFT_PLANNING.REFRESH",
    OPEN_SHIFT: "SHIFT_PLANNING.OPEN_SHIFT",
    OPEN_PHONE: "SHIFT_PLANNING.OPEN_PHONE",
  },
};
